import config from '@/config';
const storeData = {};

const gotoUrl = function (url, oriOptions) {
  if (!url) {
    return;
  }
  const options = oriOptions || {};
  const { replace = false, href = false, open = false, name = false } = options;
  if (open) {
    window.open(url);
    return;
  }
  if (href) {
    if (storeData.href) return;
    storeData.href = true;
    window.location.href = url;
    return;
  }
  window.Vue.routerGo(name ? { name: url } : { path: url }, replace);
};
/**
 * 阿拉伯号转中字
 * @param {Number} num 数字
 */
const getChinese = (num) => {
  // const changeNum = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  // const unit = ['', '十', '二十', '三十', '四十', '五十', '六十', '七十', '八十', '九十', '一百'];
  // const newNum = parseInt(num, 10);
  // let res = num;
  // if (newNum >= 10) {
  //   const a = String(num)[0];
  //   const b = String(num)[1];
  //   res = unit[a] + changeNum[b];
  // } else {
  //   res = changeNum[res];
  // }
  //
  // return res;
  // export const numberToChineseNew = (num) => {
  const arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const arr2 = [
    '',
    '十',
    '百',
    '千',
    '万',
    '十',
    '百',
    '千',
    '亿',
    '十',
    '百',
    '千',
    '万',
    '十',
    '百',
    '千',
    '亿',
  ]; // 可继续追加更高位转换值
  if (!num || isNaN(num)) {
    return '零';
  }
  const english = num.toString().split('');
  let result = '';
  for (let i = 0; i < english.length; i++) {
    // eslint-disable-next-line camelcase
    const des_i = english.length - 1 - i; // 倒序排列设值
    result = arr2[i] + result;
    // eslint-disable-next-line camelcase
    const arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  // 将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
  // 合并中间多个零为一个零
  result = result.replace(/零+/g, '零');
  // 将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
  // 将【亿万】换成【亿】
  result = result.replace(/亿万/g, '亿');
  // 移除末尾的零
  result = result.replace(/零+$/, '');
  // 将【零一十】换成【零十】
  // result = result.replace(/零一十/g, '零十');
  // 貌似正规读法是零一十
  // 将【一十】换成【十】
  result = result.replace(/^一十/g, '十');
  return result;
  // };
};

/**
 * 数组去重
 * @param {*} arr 接收的原数组
 * @param {*} key 如果是对象数组[{id: 1}, {id: 2}, {id: 3}]，则需要以什么key作为重复的标准，普通数组[1,2,3,2]不需要
 */
const arrUnique = function (arr, key) {
  let returnArr = [];
  if (key) {
    // 对象数组去重
    const obj = {};
    returnArr = arr.reduce((cur, next) => {
      obj[next[key]] ? '' : (obj[next[key]] = true && cur.push(next));
      return cur;
    }, []);
    return returnArr;
  }
  // 普通数组去重
  returnArr = arr.reduce((cur, next) => {
    !cur.includes(next) && cur.push(next);
    return cur;
  }, []);
  return returnArr;
};
const loadJs = function (options = {}) {
  const { url, onload, onerror, retry } = options;
  const el = document.createElement('script');
  el.src = url;
  if (typeof onload === 'function') {
    el.onload = onload;
  }
  el.onerror = function (...args) {
    if (typeof onerror === 'function') {
      onerror.call(this, ...args);
    }
    if (retry > 0) {
      loadJs({ url, onload, onerror, retry: retry - 1 });
    }
  };
  document.body.appendChild(el);
};
const mapQuery = function (query) {
  if (Object.prototype.toString.call(query) === '[object Object]') {
    let paramsStr = '';
    // for (const key in query) {
    //   const value = query[key];
    //   if (value !== undefined && value !== null && value !== '') {
    //     paramsStr += `&${key}=${value}`;
    //   }
    // }
    Object.keys(query).forEach((key) => {
      const value = query[key];
      if (value !== undefined && value !== null && value !== '') {
        paramsStr += `&${key}=${value}`;
      }
    });
    return paramsStr.replace('&', '?');
  }
};
const gotoHome = function () {
  gotoUrl('/saas/articleManagement.html', { replace: true, href: true });
};

const formatSecondsToMin = (seconds) => {
  if (!seconds) return 0;
  const min = parseInt(seconds / 60, 10);
  const s = seconds % 60;
  return `${min ? `${min}min` : ''} ${s ? `${s}s` : ''}`;
};
const formatMinsToHour = (mins) => {
  if (!mins) return 0;
  const hour = parseInt(mins / 60, 10);
  const min = mins % 60;
  return `${hour ? `${hour}hour` : ''} ${min ? `${min}min` : ''}`;
};
/**
 * 等待值
 * @param {*} key key名
 * @param {*} that 对象 this
 * @param {*} total 等待次数
 */
const awaitInterfaceResponse = (key, that, total) => {
  return new Promise((resolve, reject) => {
    let time = 1;
    let interval = 100;
    const totalTime = total || 10;
    const pollingValue = () => {
      // 先判断有没有值
      const value = that ? that[key] : key;
      if (value) {
        resolve();
      } else {
        console.log(time);
        if (time < totalTime) {
          interval += 100;
          time += 1;
          setTimeout(() => {
            pollingValue();
          }, interval);
        } else {
          reject();
        }
      }
    };
    pollingValue();
  });
};

/** 文件名后缀切割
 * @description: 传入包含后缀的文件名
 * @param {String} value eg: 前端进阶指南.png
 * @return {Object} { prefix, postfix } 前缀 后缀
 */
const postfixFun = (value) => {
  const temp = value;
  const arr = temp.split('.');
  const postfix = `.${arr[arr.length - 1]}`; // 后缀
  const prefix = temp.replace(postfix, ''); // 前缀
  return { prefix, postfix };
};
const getMobileDomain = function () {
  if (config.mobileDomain) return config.mobileDomain;
  const domainArr = window.location.host.split('.');
  return [`${domainArr[0]}h5`].concat(domainArr.slice(1)).join('.');
};

const getUrlDomain = function (url) {
  return url
    .replace(/https?:\/\//, '')
    .split('/')[0]
    .split(':')[0];
};

const bytesToSize = (bytes) => {
  if (bytes === 0) return '0 B';
  const k = 1000; // or 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${(bytes / k ** i).toPrecision(3)}${sizes[i]}`;
};

const downloadFileAction = (urltemp, fileName) => {
  return new Promise((resolve, reject) => {
    // const urltemp =
    //   'https://tsep-test-1304685099.cos.ap-guangzhou.myqcloud.com/tsep_dev/11501202/2fbd5f8d-ecae-471c-8856-d53624e06e72';
    const url2 = urltemp.replace(/\\/g, '/');
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url2, true);
    xhr.responseType = 'blob';
    // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
    // 为了避免大文件影响用户体验，建议加loading
    xhr.onload = () => {
      if (xhr.status === 200) {
        // 获取文件blob数据并保存
        console.log(xhr);
        console.log(xhr.response);
        const url = window.URL.createObjectURL(new Blob([xhr.response]));
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        resolve(true);
        return;
      }
      reject(false);
    };
    xhr.send();
  });
};

export {
  gotoUrl,
  getChinese,
  arrUnique,
  loadJs,
  mapQuery,
  gotoHome,
  formatSecondsToMin,
  formatMinsToHour,
  awaitInterfaceResponse,
  postfixFun,
  getMobileDomain,
  bytesToSize,
  downloadFileAction,
  getUrlDomain,
};
